module.exports = __webpack_public_path__ + "static/malar-DND3_FnP-9a1b5ffdf87f2b9c6cb904c7f21a88b9.webp";